<script>
import { mapGetters } from 'vuex'
export default {
  name: 'lemonMessageMp4',
  inheritAttrs: false,
  inject: ['IMUI'],
  render () {
    var classname = 'lemon-message lemon-message--status-succeed lemon-message-mp4'
    var displayName = this.current_user.name
    var avatar = this.current_user.headimgurl
    if (this.$attrs.message.fromUser.id === this.current_user.id) {
      classname = 'lemon-message lemon-message--status-succeed lemon-message-mp4 lemon-message--reverse'
      displayName = this.current_user.name
      avatar = this.current_user.headimgurl
    } else {
      displayName = this.$attrs.message.fromUser.displayName
      avatar = this.$attrs.message.fromUser.avatar
    }
    return (
      <div class={classname}>
        <div class="lemon-message__avatar">
          <span class="lemon-avatar" shape="square" style="width: 36px; height: 36px; line-height: 36px; font-size: 18px;">
            <img src={avatar} />
          </span>
        </div>
        <div class="lemon-message__inner">
          <div class="lemon-message__title">
            <span>{displayName}</span>
          </div>
          <div class="lemon-message__content-flex">
            <video width="30%" src={this.$attrs.message.content} controls="controls"></video>
            <div class="lemon-message__content-after">
            </div>
            <div class="lemon-message__status">
              <i class="lemon-icon-loading lemonani-spin"></i>
              <i title="重发消息" class="lemon-icon-prompt" style="color: rgb(255, 37, 37); cursor: pointer;"></i>
            </div>
          </div>
        </div>
      </div>
    )
  },
  computed: {
    ...mapGetters(['current_user'])
  }
}
</script>



// WEBPACK FOOTER //
// src/view/service/lemon-message-mp4.vue